export const useStyles = (theme) => ({
  paper: {
    padding: 30,
    width: 500,
    height: 300,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  avatarStyle: {
    width: 100,
    height: 100,
    backgroundColor: "#eee",
  },
  listStyle: {
    fontSize: 20,
    fontFamily: "Open Sans",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  linkStyle: {
    fontSize: 18,
    display: "flex",
    alignItems: "center",
  },
});
